export default __webpack_public_path__ + "static/media/video_plugin_assistant_optm.19749674.svg";